import { removeNonNumericalCharacters } from './displayUtils';

const PHONE_NUMBER_MAX_LENGTH = 10;

export function validatePhoneNumber(value: string | undefined): boolean {
  if (!value) return false;
  const phoneNumberNumeric = removeNonNumericalCharacters(value);
  return phoneNumberNumeric.length === PHONE_NUMBER_MAX_LENGTH;
}
